// @ts-nocheck
/* eslint-disable */
Mapy.Masakovac = function(id, options) {
	SMap.Layer.Marker.call(this, id, options);
	this._appendData = {};
	this._order = [];
	this._lastOrder = [];
	this._mapObj = {};
}

Mapy.Masakovac.prototype = Object.create(Object.assign({}, SMap.Layer.prototype, SMap.Layer.Marker.prototype));

Mapy.Masakovac.prototype.redraw = function(full) { // prekresleni vrstvy
	if (!this._active) { return; }

	if (SMap.TRANSFORM) { this._dom.container[SMap.LAYER_MARKER].style[SMap.TRANSFORM] = "none"; }

	const half = this.getMap().getSize().clone().scale(0.5);
	const w = half.x;
	const h = half.y;
	let beforeAppendedObj = null;

	for (let i = 0; i < this._order.length; i++) {
		const id = this._order[i];
		const obj = this._markers[id];

		if (obj) {
			const pos = obj.marker.getCoords().toPixel(this.getMap()); // pozice vuci stredu
			const dx = Math.abs(pos.x);
			const dy = Math.abs(pos.y);
			const visible = !(dx > w+this._options.prefetch || dy > h+this._options.prefetch);

			if (this._lastOrder[i] !== this._order[i]) {
				const index = this._lastOrder.indexOf(this._order[i]);

				if (index !== -1) {
					this._lastOrder.splice(index, 1);
				}

				this._lastOrder.splice(i, 0, this._order[i]);

				if (visible) {
					this.positionMarker(obj.marker);
					this._append(obj, beforeAppendedObj);
					beforeAppendedObj = obj;
				}
				else if (obj.appended) {
					this._unlink(obj);
				}
			}
			else {
				if (visible && !obj.appended) {
					this.positionMarker(obj.marker);
					this._append(obj, this._getLastAppendMarker(i-1));
					beforeAppendedObj = obj;
				}
				else if (!visible && obj.appended) {
					this._unlink(obj);
				}
				else if (obj.appended) {
					beforeAppendedObj = obj;
				}
			}

			if (visible && full) { //adjust position
				this.positionMarker(obj.marker);
			}
		}
	}

	full && this._reposition(true);
}

Mapy.Masakovac.prototype._reposition = function(full) { // prepozicovani ikonek poiu
	if (full) {
		// udelame si z markeru pole, aby byly vzdy ve stejnem poradi
		let markerArray = [];
		for (let id in this._markers) {
			markerArray.push({
				id: id,
				marker: this._markers[id]
			});
		}
		markerArray.sort(function(a, b) {
			return a.id < b.id ? -1 : 1;
		});


		let markers = {};
		let m = {};
		for (let i = 0, len = markerArray.length; i < len; i++) {
			if (markerArray[i].marker.marker instanceof Mapy.MarkerPOI && !(markerArray[i].marker.marker instanceof Mapy.MarkerDetail) && !(markerArray[i].marker.marker instanceof Mapy.MarkerSearch)) {
				markers[markerArray[i].id] = markerArray[i].marker;
				if (!markerArray[i].marker.appended) { continue; }
				m[markerArray[i].id] = markerArray[i].marker.pos;
			}
		}

		SMap.Marker.Repositioner.getInstance().go(m, markers, {}); // napozicovani do mrizky

		for (var id in m) {
			const marker = this._markers[id];
			const pos = m[id];
			if (pos.x === null) {
				this._unlink(marker);
				continue;
			}
			marker.pos = pos;
			const c = marker.marker.getContainer();
			for (let p in c) {
				c[p].style.left = pos.x + "px";
				c[p].style.top = pos.y + "px";
			}
		}
	}
}

Mapy.Masakovac.prototype._append = function(obj, beforeObj) {
	const marker = obj.marker;
	const c = marker.getContainer();

	for (var p in c) {
		if (!(p in this._dom.container)) { throw new Error("Cannot append marker component to layer"); }
		var node = c[p];
		node.style.position = "absolute";
		if (beforeObj?.marker?.getContainer() && beforeObj?.marker?.getContainer()[p]) {
			beforeObj?.marker?.getContainer()[p].after(node);
		}
		else {
			this._dom.container[p].appendChild(node);
		}
	}

	obj.appended = true;
}

Mapy.Masakovac.prototype._getLastAppendMarker = function(index)  {
	let lastAppendMarker = null;

	for (let i = index; i > -1; i--) {
		if (this._markers[this._order[i]]?.appended) {
			lastAppendMarker = this._markers[this._order[i]];
			break;
		}
	}

	return lastAppendMarker;
}

Mapy.Masakovac.prototype.changeMarkers = function(markers, noRedraw) {
	let newOrder = [];

	for (let i = 0; i < markers.length; i++) {
		const marker = markers[i];
		const id = markers[i].getId();

		newOrder.push(id);

		if (this._order.indexOf(id) == -1) {
			this._markers[id] = {
				appended: false,
				marker,
				pos: null,
			}

			marker.setOwner(this);
		}
	}

	for (let i = 0; i < this._order.length; i++) {
		if (newOrder.indexOf(this._order[i]) === -1) {
			this._markers[this._order[i]] && this._removeMarker(this._markers[this._order[i]].marker);
			const index = this._lastOrder.indexOf(this._order[i]);

			if (index !== -1) {
				this._lastOrder.splice(index, 1);
			}
		}
	}

	this._order = newOrder;

	!noRedraw && this.redraw();
}
